import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
const textCellVariants = cva('flex items-center md:text-sm/4.5 lg:text-base/6 md:p-4', {
  variants: {
    variant: {
      text: 'md:px-2 lg:px-4 font-normal text-foreground',
      comment: 'text-xs/4.5 md:text-xs/4.5 lg:text-base/6 md:py-1 md:px-2 lg:px-4 text-foreground/70 font-semibold',
      header: 'px-6 md:px-2 lg:px-4 py-2 text-foreground font-semibold',
      sectionHeader: 'md:px-2 lg:px-4 font-semibold text-foreground/70'
    }
  },
  defaultVariants: {
    variant: 'text'
  }
});
export interface TableCellProps extends React.ComponentProps<'div'> {
  variant?: VariantProps<typeof textCellVariants>['variant'];
}
function TextCell(t0) {
  const $ = _c(12);
  let children;
  let className;
  let props;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      children,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = variant;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    variant = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== variant) {
    t1 = cn(textCellVariants({
      variant
    }), className);
    $[5] = className;
    $[6] = variant;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== props || $[10] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[8] = children;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
export { TextCell };